import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "src/app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TablerIconsModule } from 'angular-tabler-icons';
import { CustomPipesModule } from 'src/app/pipe/customPipes.module';
import { CluAgentService } from "./clu-agent.service";
import { CluAgentSettingsDevicesComponent } from "./clu-agent-settings-devices/clu-agent-settings-devices.component";
import { MdCluSettingsStandardPrinterDialogComponent } from "./@modals/md-clu-settings-standard-printer-dialog/md-clu-settings-standard-printer-dialog.component";
import { MdCluAgentSettingsDevicesDialogComponent } from "./@modals/md-clu-agent-settings-devices-dialog/md-clu-agent-settings-devices-dialog.component";

@NgModule({
    declarations: [
        CluAgentSettingsDevicesComponent,
        MdCluSettingsStandardPrinterDialogComponent,
        MdCluAgentSettingsDevicesDialogComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        MaterialModule, 
        FormsModule,
        ReactiveFormsModule,
        TablerIconsModule, 
        CustomPipesModule, 
    ],
    providers: [/*CluAgentService*/],
    exports: [CluAgentSettingsDevicesComponent]
})
export class CluAgentModule {}